var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3938_45528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM22.5986 10.0859C22.248 9.92352 21.7291 10.0055 21.127 10.2148C20.3006 10.5021 9.73631 14.8277 9.12598 15.0781C8.54723 15.3151 8 15.5738 8 15.9482C8.00009 16.2114 8.16199 16.3598 8.6084 16.5137C9.07314 16.6734 10.2436 17.0155 10.9346 17.1992C11.6 17.3765 12.3575 17.2222 12.7822 16.9678C13.2323 16.6981 18.426 13.3465 18.8008 13.0518C19.1733 12.758 19.4706 13.1344 19.166 13.4287C18.8598 13.724 15.2953 17.0603 14.8252 17.5225C14.2543 18.0836 14.6601 18.6656 15.043 18.8984C15.4819 19.1651 18.6259 21.199 19.0996 21.5254C19.5734 21.8519 20.0543 22 20.4941 22C20.9337 21.9996 21.1658 21.4407 21.3848 20.792C21.6417 20.0302 22.8436 12.4629 22.9922 10.9717C23.0369 10.5202 22.8885 10.2199 22.5986 10.0859Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3938_45528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLight);
export default __webpack_public_path__ + "static/media/telegram-light.9dc2e0913ec6578e668138c0953ac07c.svg";
export { ForwardRef as ReactComponent };